module.exports = __webpack_public_path__ + "img/Wechat_icon.bdd16f2.svg";